export default {"src":"/login-app/[GIT_HASH]/_next/static/media/zoom_in.28f0fde3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};